// extracted by mini-css-extract-plugin
export default {"container":"components-parity-insight-hotels-block-module__container","infinite-scroller":"components-parity-insight-hotels-block-module__infinite-scroller"};